import { render, staticRenderFns } from "./XInputMemberStatuses.vue?vue&type=template&id=295dae46"
import script from "./XInputMemberStatuses.vue?vue&type=script&lang=js"
export * from "./XInputMemberStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports